import React from 'react';
import { ListItemWithText } from '@ihsm/ui-shared/lib/typings/shared/components/ListWithRowDrag/types';
import './DraggableItemWithDropdown.scss';

export interface DraggableItemWithDropdownProps extends ListItemWithText {
  text: string;
  selectedOption?: string;
  options?: string[];
  onRemove: () => void;
  onChangeOption: (value: string) => void;
}

export const DraggableItemWithDropdown: React.FC<
  DraggableItemWithDropdownProps
> = ({
  text,
  options,
  selectedOption,
  onRemove = () => {},
  onChangeOption = () => {},
}): JSX.Element => (
  <div className="draggable-item-with-dropdown">
    <div className="draggable-item-with-dropdown__text">{text}</div>

    {options && options.length > 0 ? (
      <select
        onChange={(e) => onChangeOption(e.target.value)}
        className="draggable-item-with-dropdown__badge"
        value={selectedOption}
      >
        {options.map((option) => (
          <option key={option}>{option}</option>
        ))}
      </select>
    ) : null}

    <button
      onClick={onRemove}
      type="button"
      className="draggable-item-with-dropdown__remove"
    >
      &times;
    </button>
  </div>
);
